'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_scala$002eutil$002e$002dEither from "./scala.util.-Either.js";
var $p;
/** @constructor */
function $c_Lsamples_EitherSample$package$$anon$10(evaluator$11) {
  this.L0 = null;
  this.L0 = evaluator$11;
}
export { $c_Lsamples_EitherSample$package$$anon$10 as $c_Lsamples_EitherSample$package$$anon$10 };
$p = $c_Lsamples_EitherSample$package$$anon$10.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_EitherSample$package$$anon$10;
/** @constructor */
function $h_Lsamples_EitherSample$package$$anon$10() {
}
export { $h_Lsamples_EitherSample$package$$anon$10 as $h_Lsamples_EitherSample$package$$anon$10 };
$h_Lsamples_EitherSample$package$$anon$10.prototype = $p;
$p.b = (function() {
  return "<function0>";
});
$p.v = (function() {
  var v = this.L0.h();
  return ((v instanceof $j_scala$002eutil$002e$002dEither.$c_s_util_Either) ? new $j_java$002elang$002e$002dObject.$c_s_Some(v) : $j_java$002elang$002e$002dObject.$m_s_None$());
});
$p.h = (function() {
  return this.v();
});
var $d_Lsamples_EitherSample$package$$anon$10 = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_EitherSample$package$$anon$10, "samples.EitherSample$package$$anon$10", ({
  oJ: 1,
  d: 1,
  a: 1,
  f: 1
}));
export { $d_Lsamples_EitherSample$package$$anon$10 as $d_Lsamples_EitherSample$package$$anon$10 };
